import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the promotional codes table view.
 * @extends JetView
 */
export default class tablePromotionalCodesView extends JetView {
    /**
     * Configures the datatable for promotional codes.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID of the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
            columns: [
                // Column definitions
                {
                    id: 'rating', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: 'Editar', // Tooltip text
                    template: function (obj) {
                        // Template function for rendering
                        return '';
                        if (devConfig.getPermAction('promotionalCodesEdit', 'Edit')) {
                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                        } else {
                            return '';
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Code', header: _('Código'), width: 250, sort: 'int' }, // Code column with localization
                { id: 'Name', header: _('Nombre'), width: 250, sort: 'int' }, // Name column with localization
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'), // Creation date column with localization
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'State',
                    header: _('Estado'), // State column with localization
                    options: [
                        { id: 'A', value: _('Activo') }, // Active state option
                        { id: 'I', value: _('Inactivo') }, // Inactive state option
                    ],
                    width: 150,
                    sort: 'int', // Sorting type
                },
                { id: 'UserId', header: _('Usuario'), width: 250, sort: 'int' }, // User ID column with localization
                {
                    id: 'Partner',
                    header: _('Partner'), // Partner column with localization
                    width: 250,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Function',
                    header: _('Función'), // Function column with localization
                    options: [{ id: '1', value: _('Registro') }], // Function options
                    width: 150,
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handler for click events
                edit: function (euv, id) {
                    $$('EditCode').show(); // Show edit popup
                },
            },
            ready: function () {
                // Event handler for when the datatable is ready
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // No data message
                            '</div>',
                    );
                }
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math functions
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the datatable and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/PromotionalCodes/GetCodes?Partner=' + id_partner + '&'; // API URL for fetching codes
        var filter = ''; // Filter string for API requests

        // Event handler for promotional codes filtering
        this.on(this.app, 'promotionalCodes:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to filter string
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });

        // Event handler for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });

        // Popup for editing promotional codes
        var popup = webix.ui({
            view: 'window',
            id: 'EditCode', // ID of the edit popup
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Código') }, // Edit label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal window
            body: {
                view: 'form',
                id: 'editForm', // ID of the edit form
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // ID field
                    { view: 'text', label: _('Código'), name: 'Code' }, // Code field with localization
                    { view: 'text', label: _('Nombre'), name: 'Name' }, // Name field with localization
                    {
                        view: 'text',
                        label: _('Fecha de Creación'), // Creation date field with localization
                        name: 'CreatedLocalDate',
                        readonly: true, // Read-only field
                    },
                    {
                        view: 'combo',
                        label: _('Estado'), // State field with localization
                        name: 'State',
                        options: [
                            { id: 'A', value: _('Activado') }, // Activated state option
                            { id: 'I', value: _('Inactivado') }, // Deactivated state option
                        ],
                    },
                    { view: 'text', label: _('Usuario'), name: 'User' }, // User field with localization
                    {
                        view: 'combo',
                        label: _('Función'), // Function field with localization
                        name: 'Function',
                        options: [{ id: '1', value: _('Registro') }], // Function options
                        readonly: true, // Read-only field
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup on cancel
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'PromotionalCodes/UpdateCode',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Code":"' +
                                                values.Code +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '" ,"State":"' +
                                                values.State +
                                                '", "User":"' +
                                                values.User +
                                                '", "Function":"' +
                                                values.Function +
                                                '", "Partner":"' +
                                                id_partner +
                                                '"}', // Send updated code data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Código Actualizado'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Get current date formatted for creation date
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2);

        // Popup for adding promotional codes
        var popupAdd = webix.ui({
            view: 'window',
            id: 'AddCode', // ID of the add popup
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Código') }, // Add label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal window
            body: {
                view: 'form',
                id: 'addform', // ID of the add form
                elements: [
                    { view: 'text', label: _('Código'), name: 'Code' }, // Code field with localization
                    { view: 'text', label: _('Nombre'), name: 'Name' }, // Name field with localization
                    {
                        view: 'combo',
                        label: _('Usuario'), // User field with localization
                        name: 'User',
                        options: {
                            body: {
                                dataFeed: function (text) {
                                    // Data feed for user selection
                                    var vthis = this;
                                    if (text.length > 2) {
                                        // Trigger on input length
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'es/Select/BetShopsSelect',
                                                '{"Filter":"' + text + '"}', // Send filter for user selection
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error! '); // Show error message
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var resp = JSON.parse(text); // Parse response
                                                        if (!resp.HasError) {
                                                            vthis.parse(
                                                                resp.Data, // Parse user data
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    }
                                },
                            },
                        },
                    },
                    {
                        view: 'combo',
                        label: _('Función'), // Function field with localization
                        name: 'Function',
                        options: [{ id: '1', value: _('Registro') }], // Function options
                    },
                    {
                        view: 'combo',
                        label: _('Estado'), // State field with localization
                        name: 'State',
                        options: [
                            { id: 'A', value: _('Activado') }, // Activated state option
                            { id: 'I', value: _('Inactivado') }, // Deactivated state option
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'PromotionalCodes/SaveCode',
                                            '{"Code":"' +
                                                values.Code +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "User":"' +
                                                values.User +
                                                '", "Function":"' +
                                                values.Function +
                                                '", "State":"' +
                                                values.State +
                                                '", "Partner":"' +
                                                id_partner +
                                                '"}', // Send new code data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text); // Parse response
                                                    if (json.HasError) {
                                                        webix.message({
                                                            title: _('¡Error!'), // Error title
                                                            type: 'alert-error',
                                                            text: json.AlertMessage, // Show alert message
                                                        });
                                                    } else {
                                                        webix.message(
                                                            _('Código Agregado'), // Show success message
                                                        );
                                                        grid.clearAll(); // Clear grid data
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    }
                                                },
                                            },
                                        );
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Event handler for showing add code popup
        this.on(this.app, 'addCode:button', (filter) => {
            popupAdd.show(); // Show add code popup
        });

        $$('editForm').bind($$('datatable')); // Bind edit form to datatable
    }
}

// FILE DOCUMENTED
